function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M6.47 12.07a.83.83 0 01-.28 1.63A6.95 6.95 0 01.37 6.8c0-1.65.75-2.93 1.6-3.88.37-.43.77-.8 1.16-1.12h-.78a.8.8 0 010-1.6h3.01a.8.8 0 01.8.8v3.02a.8.8 0 01-1.6 0V2.77c-.45.35-.93.76-1.36 1.24A4.15 4.15 0 002 6.79a5.3 5.3 0 004.46 5.28zM4.56 2.4l.3-.23v1.86a.5.5 0 001 0V1a.5.5 0 00-.5-.5H2.35a.5.5 0 000 1h1.64l-.39.3c-.45.37-.96.8-1.41 1.31A5.49 5.49 0 00.67 6.8c0 3.63 2.65 6.1 5.57 6.6a.52.52 0 00.18-1.03 5.6 5.6 0 01-4.7-5.57c0-1.2.53-2.18 1.25-2.99.51-.57 1.08-1.03 1.59-1.42zm8.07 8.7c-.38.42-.78.79-1.17 1.1h.79a.8.8 0 110 1.61H9.23a.8.8 0 01-.8-.8V9.98a.8.8 0 011.6 0v1.25c.46-.35.93-.76 1.36-1.24a4.15 4.15 0 001.19-2.79 5.3 5.3 0 00-4.39-5.26.82.82 0 11.3-1.62 6.95 6.95 0 015.73 6.88c0 1.65-.74 2.93-1.6 3.88zM8.44.6a.52.52 0 10-.2 1.03 5.6 5.6 0 014.64 5.56c0 1.2-.54 2.18-1.26 2.99a11.04 11.04 0 01-1.86 1.63l-.03.02V9.98a.5.5 0 00-1 0V13a.5.5 0 00.5.5h3.02a.5.5 0 000-1H10.6l.39-.3c.45-.37.96-.8 1.41-1.31a5.49 5.49 0 001.52-3.69c0-3.6-2.6-6.04-5.48-6.59z",
  clipRule: "evenodd"
});

function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    fill: "none",
    viewBox: "0 0 15 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.860d0952.svg";
export { ForwardRef as ReactComponent };